import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import ServerSideDataSource from './ServerSideDataSource.js';
import { isEqual } from 'lodash';

class DynamicTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			gridApi: null,
		};
		this.gridRef = React.createRef();
	}

	gridOptions = () => {
		const { data } = this.props;
		return {
			modules: AllModules,
			columnDefs: data.columnDefs,
			cacheBlockSize: 200,
			maxBlocksInCache: 6,
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
			rowHeight: 35,
			rowModelType: 'serverSide',
			maxConcurrentDatasourceRequests: 1,
			multiSortKey: 'ctrl',
			enableRangeSelection: true,
			suppressCutToClipboard: true,
		};
	};

	defaultColDefs = {
		flex: 1,
		minWidth: 100,
		resizable: true,
		editable: false,
	};

	componentDidMount() {
		const { data } = this.props;
		const gridOptionsnew = {
			data,
			suppressRowClickSelection: true,
			...this.gridOptions(),
		};
		const datasource = ServerSideDataSource(
			gridOptionsnew,
			this.gridRef.current.columnApi,
			this.gridRef.current.api
		);
		this.gridRef.current.api.setServerSideDatasource(datasource);
	}

	componentDidUpdate(prevProps) {
		const { filters } = this.props;
		if (!isEqual(filters, prevProps.filters)) {
			const { data } = this.props;
			const gridOptionsnew = {
				data,
				suppressRowClickSelection: true,
				...this.gridOptions(),
			};
			const datasource = ServerSideDataSource(
				gridOptionsnew,
				this.gridRef.current.columnApi,
				this.gridRef.current.api
			);
			this.gridRef.current.api.setServerSideDatasource(datasource);
		}
	}

	onGridReady = params => {
		this.setState({ gridApi: params.api });
		const { data } = this.props;
		const gridOptionsnew = {
			data,
			suppressRowClickSelection: true,
			...this.gridOptions(),
		};
		const datasource = ServerSideDataSource(
			gridOptionsnew,
			params.columnApi,
			params.api
		);
		params.api.setServerSideDatasource(datasource);
	};

	render() {
		const { data } = this.props;

		return (
			<>
				<div style={{ height: '400px' }} className="ag-theme-balham">
					<AgGridReact
						{...this.gridOptions()}
						ref={this.gridRef}
						modules={AllModules}
						columnDefs={data.columnDefs}
						cacheBlockSize={200}
						defaultColDef={this.defaultColDefs}
						maxBlocksInCache={6}
						enableGroupEdit={true}
						rowModelType="serverSide"
						maxConcurrentDatasourceRequests={1}
						multiSortKey="ctrl"
						onGridReady={this.onGridReady}
						enableRangeSelection={true}
						suppressCutToClipboard={true}
						suppressCellFocus={true}
					/>
				</div>
			</>
		);
	}
}

export default DynamicTable;
